module.exports = __webpack_public_path__ + "static/media/ic_round-plus.bec98321.svg";